import { forceSessionLogout } from "@/infrastructure/services/auth/forceSessionLogout";
import { recoverStudioSession } from "@/infrastructure/services/auth/recoverStudioSession";

const AUTH0_SESSION_DEAD_CODES = new Set(["AUTH0_TOKEN_ERROR", "AUTH0_TOKEN_UNAVAILABLE"]);

export type StudioUnauthorizedAction = "retry" | "logout" | "reject";

/**
 * On studio-session 401: re-fetch Auth0 identity + studio session (user + tokens).
 * - recovered / already fresh → caller should retry the original request
 * - Auth0 session dead → force logout
 * - other transient failures → reject without logging the user out
 */
export async function handleStudioUnauthorized(): Promise<StudioUnauthorizedAction> {
  const recovery = await recoverStudioSession();

  if (recovery.status === "recovered" || recovery.status === "already_fresh") {
    return "retry";
  }

  const code = recovery.result.code;
  if (code && AUTH0_SESSION_DEAD_CODES.has(code)) {
    forceSessionLogout();
    return "logout";
  }

  return "reject";
}
